import React from "react";
import { Wallet } from "lucide-react";
import { indicadorAnticipo } from "../lib/anticipos";

// Indicador DISCRETO del estado del anticipo de una cita (CL.4 A2).
//
// · `no_requiere` (o sin el campo) → no se pinta nada.
// · Pinta el ícono de cartera + una palabra corta («Recibido», «Vencido»…): a 390 px la
//   etiqueta larga quedaba en «Antic…» (Corrección 1). La etiqueta completa («Anticipo
//   recibido») va en `title` y `aria-label`.
// · Con `onAbrir` es un botón que abre la ventana del anticipo; sin él, es sólo una marca.
//   El padre decide si lo pasa: en sesión demo y sin la capacidad `cobros` NO lo pasa, para
//   no ofrecer una puerta que el backend va a cerrar con un 403 genérico (DT.71).
// · 🔴 `e.stopPropagation()`, igual que el lápiz y el botón de cobrar: en la Agenda el clic
//   en la celda CICLA EL ESTADO de la cita.
export default function AnticipoIndicador({ cita, onAbrir, testid }) {
  const ind = indicadorAnticipo(cita?.anticipo_estado, cita?.status);
  if (!ind) return null;
  const cls = `inline-flex items-center gap-1 whitespace-nowrap text-[10px] font-medium border rounded-full px-1.5 py-0.5 ${ind.clase}`;
  const id = testid || `anticipo-ind-${cita.id}`;
  const contenido = (
    <>
      <Wallet className="w-3 h-3 shrink-0" aria-hidden="true" />
      <span>{ind.corta}</span>
    </>
  );
  if (!onAbrir) {
    return (
      <span className={cls} title={ind.etiqueta} aria-label={ind.etiqueta} data-testid={id} data-estado={ind.estado}>
        {contenido}
      </span>
    );
  }
  return (
    <button
      type="button"
      onClick={(e) => { e.stopPropagation(); onAbrir(cita); }}
      onKeyDown={(e) => e.stopPropagation()}
      className={`${cls} hover:brightness-95`}
      title={ind.etiqueta}
      aria-label={ind.etiqueta}
      data-testid={id}
      data-estado={ind.estado}
    >
      {contenido}
    </button>
  );
}
